import { AiFillGithub, AiFillLinkedin } from 'react-icons/ai'

export const socialData = [
    {
        id: 1,
        icon: < AiFillGithub />,
        name: 'GitHub',
        link: 'https://github.com/anhthu106',
    },
    {
        id: 2,
        icon: < AiFillLinkedin />,
        name: 'LinkedIn',
        link: 'https://www.linkedin.com/in/thupham106/',
    },
];